import React from 'react'
import { NavBar } from '../components/navBar'
import { Journal } from '../components/journal'

export const JournalScreen = () => {
  return (
    <>
      <NavBar />
      <Journal />
    </>
  );
};
